<template>
  <div>
    <JobExecConfirm ref="JobExecConfirm"></JobExecConfirm>
    <Card>
      <Row>
        <Col span="24" :lg="22">
          <Form :model="searchForm" ref="searchForm" inline :label-width="60">
            <FormItem label="作业名称">
              <Input v-model="searchForm.name" style="min-width: 200px" />
            </FormItem>
            <FormItem label="作业描述">
              <Input v-model="searchForm.desc" style="min-width: 200px" />
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getTableData()">搜索</Button>
              <Button style="margin-left: 8px" @click="searchReset">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="24" :lg="2">
          <Button
            style="float: right;"
            @click="editJob(0)"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">创建作业</Button>
        </Col>
      </Row>
      <Table
        border
        :loading="TableLoading"
        :data="job.data"
        :columns="job.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page
            :total="job.count"
            :current="job.page"
            :page-size="job.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getOpsCenterJob, deleteOpsCenterJob, getOpsCenterJobUnfinishedExecLog } from '@/api/opscenter'
import JobExecConfirm from './job-exec-confirm'

export default {
  name: 'job-list',
  components: {
    JobExecConfirm
  },
  data () {
    return {
      TableLoading: false,
      job: {
        data: [],
        columns: [
          {
            title: '作业ID',
            key: 'id',
            tooltip: true,
            align: 'center',
            minWidth: 80
          },
          {
            title: '作业名称',
            key: 'name',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '作业描述',
            key: 'desc',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '创建用户',
            tooltip: true,
            align: 'center',
            key: 'create_user_full_name',
            minWidth: 90
          },
          {
            title: '创建时间',
            tooltip: true,
            align: 'center',
            key: 'created_format',
            minWidth: 150
          },
          {
            title: '最后修改用户',
            tooltip: true,
            align: 'center',
            key: 'change_user_full_name',
            minWidth: 120
          },
          {
            title: '最后修改时间',
            tooltip: true,
            align: 'center',
            key: 'changed_format',
            minWidth: 150
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 220,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: 'job_detail',
                        params: { 'id': params.row.id }
                      })
                    }
                  }
                }, '详情'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$refs.JobExecConfirm.exec(params.row.id)
                    }
                  }
                }, '执行'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      getOpsCenterJobUnfinishedExecLog({ job: params.row.id }).then(res => {
                        if (res.data) {
                          this.$Notice.warning({
                            title: '操作失败！',
                            desc: '当前作业正在执行，不允许编辑'
                          })
                        } else {
                          this.$router.push({
                            name: 'job_edit',
                            params: { id: params.row.id }
                          })
                        }
                      }).catch(res => {
                        if (res.request) {
                          this.$Notice.error({
                            title: '操作失败，获取执行数据失败!',
                            desc: res.request.responseText
                          })
                        } else {
                          this.$Notice.error({
                            title: '操作失败！服务器无响应'
                          })
                        }
                      })
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.Delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 10
      },
      searchForm: {
        name: '',
        desc: ''
      }
    }
  },
  mounted: function () {
    this.getTableData()
  },
  methods: {
    // 打开编辑作业
    editJob (id) {
      if (id) {
        this.$router.push({
          name: 'job_edit',
          params: { id: id }
        })
      } else {
        this.$router.push({
          name: 'job_add'
        })
      }
    },
    // 获取作业列表数据
    getTableData (value = 1) {
      this.job.page = value
      let params = {
        size: this.job.size,
        page: this.job.page,
        name: this.searchForm.name,
        desc: this.searchForm.desc
      }
      this.TableLoading = true
      getOpsCenterJob(params).then(res => {
        this.TableLoading = false
        this.job.data = res.data.results
        this.job.count = res.data.count
      }).catch(res => {
        this.TableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取作业列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取作业列表失败！服务器无响应'
          })
        }
      })
    },
    // 删除
    Delete (row) {
      deleteOpsCenterJob(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 初始化搜索表单
    searchReset () {
      this.searchForm = {
        name: '',
        desc: ''
      }
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
